import { styled as muiStyled } from "@mui/material/styles";

// Dashboard styled components pass `ownerState`; use loose typing during the JS→TS migration.
const styled = ((component: any, options?: any) => {
  const styledFactory = muiStyled(component, options);

  if (typeof styledFactory === "function") {
    return (styles: any) => styledFactory(styles);
  }

  return styledFactory;
}) as any;

export default styled;
